let isTapGuardSetup = false;
let touchStartX = 0;
let touchStartY = 0;
let touchMoved = false;
let lastScrollTouchTs = 0;

const MAX_MOVEMENT = 8; // pixels
const CLICK_SUPPRESS_MS = 700;

export function setupTapGuard() {
  if (isTapGuardSetup) return;
  isTapGuardSetup = true;

  document.addEventListener(
    "touchstart",
    (e) => {
      const touch = e.touches[0];
      if (!touch) return;

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchMoved = false;
    },
    { passive: true },
  );

  document.addEventListener(
    "touchmove",
    (e) => {
      const touch = e.touches[0];
      if (!touch) return;

      const dx = Math.abs(touch.clientX - touchStartX);
      const dy = Math.abs(touch.clientY - touchStartY);
      if (dx > MAX_MOVEMENT || dy > MAX_MOVEMENT) {
        touchMoved = true;
      }
    },
    { passive: true },
  );

  document.addEventListener(
    "touchend",
    (e) => {
      const touch = e.changedTouches[0];
      if (!touch) return;

      const dx = Math.abs(touch.clientX - touchStartX);
      const dy = Math.abs(touch.clientY - touchStartY);

      if (touchMoved || dx > MAX_MOVEMENT || dy > MAX_MOVEMENT) {
        lastScrollTouchTs = Date.now();
      }
    },
    { passive: true },
  );

  // iOS Safari can emit a synthetic click after scroll end.
  document.addEventListener(
    "click",
    (e) => {
      const elapsed = Date.now() - lastScrollTouchTs;
      if (elapsed >= 0 && elapsed < CLICK_SUPPRESS_MS) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true,
  );
}
